import { LucideIcon } from 'lucide-react';
import React, { useState } from 'react';
import { VideoLightbox } from './VideoLightbox';

interface PlayIconProps {
  icon: LucideIcon;
  iconColor?: string;
  size?: number;
  videoUrl: string;
  id?: string;
  label?: string;
}

export const PlayIcon: React.FC<PlayIconProps> = ({
  icon: Icon,
  iconColor = '#7856cd',
  size = 32,
  videoUrl,
  id,
  label,
}) => {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleClick = () => {
    setShowVideoModal(true);
  };

  return (
    <>
      <div
        id={id}
        className="relative flex cursor-pointer items-center gap-2"
        onClick={handleClick}
      >
        <Icon
          className="h-6 w-6"
          style={{ color: iconColor, width: size, height: size }}
        />
        {label && <span className="text-sm" style={{ color: iconColor }}>{label}</span>}
      </div>
      <VideoLightbox
        videoUrl={videoUrl}
        isOpen={showVideoModal}
        onOpenChange={setShowVideoModal}
      />
    </>
  );
};
